var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.121 2.636-1.757-1.757c-1.172-1.172-3.071-1.172-4.243 0l-16.52 16.52-.593 5.351c-.08.716.526 1.322 1.242 1.242l5.353-.595 16.52-16.52c1.17-1.17 1.17-3.07 0-4.242zm-15.401 13.644c.293.293.767.293 1.06 0l8.47-8.47 1.409 1.41-10.503 10.502v-1.628h-2.25v-2.25h-1.628l10.502-10.504 1.41 1.409-8.47 8.47c-.293.293-.293.767 0 1.06zm-1.807 5.686-2.765.307-1.42-1.42.306-2.766.931-.93h1.629v2.25h2.25v1.628l-.93.93zm16.148-16.148-2.341 2.341-3.88-3.879 2.341-2.34c.586-.587 1.535-.587 2.121 0l1.758 1.757c.586.586.586 1.535 0 2.121z",
    fill: "#01213f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPost);
export default __webpack_public_path__ + "static/media/icn_post.5a74317270d841290de5402bf008d386.svg";
export { ForwardRef as ReactComponent };